import React from "react";
import { Helmet } from "react-helmet";

const Politicas = () => {
  return (
    <div id="policie">
      <Helmet>
        <title>ABX Shipping - Política de Privacidad</title>
      </Helmet>
      <div className="container">
        <h2>
          Política de Privacidad de Airbox Shipping S.A.C. – Clientes y Público
          Externo
        </h2>

        <p>
          <strong>1. Introducción y Marco Legal</strong>
          <br />
          Airbox Shipping S.A.C. (en adelante, “la Empresa”), identificada con
          RUC N.° 20612287199 y domicilio fiscal en Av. Talavera de la Reina 133
          Dpto. 102 Urb. Las Lomas de La Molina Vieja Et. Dos, en cumplimiento
          de la Ley N.° 29733 – Ley de Protección de Datos Personales (Perú), el
          Decreto Supremo N.° 003-2013-JUS, y estándares internacionales como
          GDPR y PCI DSS, declara su compromiso con la privacidad y protección
          de los datos personales.
        </p>

        <p>
          <strong>2. Datos que recopilamos</strong>
        </p>
        <ul>
          <li>
            - Datos de identificación: nombre, apellidos, DNI, RUC, dirección,
            correo, teléfono.
          </li>
          <li>
            - Datos transaccionales: información de envíos, historial de compras,
            reclamos.
          </li>
          <li>
            - Datos financieros: comprobantes, cuentas bancarias, datos parciales
            de tarjetas.
          </li>
          <li>
            -Datos digitales: IP, cookies, historial de navegación,
            geolocalización aproximada.
          </li>
        </ul>
        <p>
          Conforme al art. 2 de la Ley 29733, toda información que identifique a
          una persona natural es considerada dato personal.
        </p>

        <p>
          <strong>3. Finalidades del tratamiento</strong>
          <br />
          Los datos se usan para: ejecución contractual, cumplimiento legal
          (SUNAT, Aduanas), facturación, atención al cliente, envío de
          promociones con consentimiento y seguridad digital antifraude.
        </p>

        <p>
          <strong>4. Base legal del tratamiento</strong>
        </p>
        <ul>
          <li>- Consentimiento del titular (art. 12, Ley 29733).</li>
          <li>- Ejecución contractual.</li>
          <li>- Cumplimiento legal (art. 14, Ley 29733).</li>
          <li>
            - Interés legítimo (seguridad, prevención de fraude, mejora del
            servicio).
          </li>
        </ul>

        <p>
          <strong>5. Tratamiento y almacenamiento de datos financieros</strong>
          <br />
          La Empresa no almacena datos completos de tarjetas. El procesamiento
          se hace mediante pasarelas certificadas PCI DSS. Los datos capturados
          son parciales (últimos dígitos, titular, vencimiento) y se emplea
          cifrado SSL/TLS para garantizar seguridad.
        </p>

        <p>
          <strong>6. Transferencia y destinatarios de datos</strong>
          <br />
          Los datos podrán compartirse con: autoridades competentes, proveedores
          logísticos (aerolíneas, courier, aduana), y entidades
          financieras/pasarelas de pago. Nunca se venden o ceden con fines
          comerciales ajenos.
        </p>

        <p>
          <strong>7. Seguridad de la información</strong>
          <br />
          Se aplican medidas técnicas y organizativas: cifrado de datos, accesos
          restringidos, políticas de confidencialidad, monitoreo de sistemas.
          Conforme al art. 28 del Reglamento DS 003-2013-JUS, se aplican medidas
          razonables de seguridad.
        </p>

        <p>
          <strong>8. Derechos de los titulares (ARCO)</strong>
          <br />
          El cliente puede ejercer sus derechos de:
        </p>
        <ul>
          <li>- Acceso</li>
          <li>- Rectificación</li>
          <li>- Cancelación</li>
          <li>- Oposición</li>
          <li>- Revocación de consentimiento</li>
        </ul>
        <p>
          Para ejercerlos, enviar solicitud a:{" "}
          <strong>correo@airboxshipping.pe</strong>
          <br />
          Dirección: [Dirección fiscal completa].
        </p>

        <p>
          <strong>9. Uso de cookies y tecnologías similares</strong>
          <br />
          El sitio web emplea cookies para mejorar experiencia, analizar tráfico
          y personalizar publicidad. El usuario puede desactivarlas en su
          navegador, aunque algunas funciones pueden verse limitadas.
        </p>

        <p>
          <strong>10. Conservación de datos</strong>
          <br />
          Los datos se conservarán mientras dure la relación contractual, por
          plazos legales tributarios/aduaneros y para atender reclamos
          posteriores.
        </p>

        <p>
          <strong>11. Modificaciones a la política</strong>
          <br />
          Airbox Shipping podrá modificar esta política en cualquier momento.
          Las actualizaciones serán publicadas en{" "}
          <a
            href="https://www.airboxshipping.pe"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.airboxshipping.pe
          </a>
          .
        </p>

        <p>
          <em>Última actualización: 01/09/2025</em>
        </p>
      </div>
    </div>
  );
};

export default Politicas;
